// GoogleHotels.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const Bus424 = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://www.tib.org/documents/20124/420692/L424%2C+2025.04.01+a+2025.10.31.pdf/87fbb728-08bb-c63b-7aeb-9b88febee8eb?version=1.0&t=1742804025399",
  };

  return (
    <>
      <button className="full-width-button" onClick={() => setShowModal(true)}>
        <i className="bi bi-bus-front icon-space" />
        424
      </button>
      {showModal && (
        <LanguageModal
          title="Bus 424"
          icon="bi bi-bus-front"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default Bus424;
